import * as XLSX from 'xlsx';

export type TemplateFormat = 'xlsx' | 'csv';

const HEADERS = ['Nacionalidade', 'Documento', 'Nome', 'Email'];

const EXAMPLE_ROWS: string[][] = [
	['Brasileiro', '529.982.247-25', 'João da Silva', 'joao@example.com'],
	['Estrangeiro', 'ORCID-0000-0001', 'Jane Doe', 'jane@example.com'],
];

export function downloadTemplate(format: TemplateFormat): void {
	const data = [HEADERS, ...EXAMPLE_ROWS];
	const worksheet = XLSX.utils.aoa_to_sheet(data);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, 'Autores');

	const filename = `template-autores.${format}`;
	XLSX.writeFile(workbook, filename, {
		bookType: format,
	});
}
